export default __webpack_public_path__ + "static/media/Astro_Pluto_Black.69ceea44.png";